import IncidentRosterView from 'components/IncidentConfig/IncidentRosterView';
import { StylishNewButton } from 'components/DesignSystems/New/StylishNewButton';
import {
  useActualIncidentId,
  useGroupGuid,
} from 'components/IAP/hooks/commonHooks';
import {
  useMarkIncidentUserActive,
  useRemoveSelfFromRoster,
  useRemoveMemberFromIncidentRoster,
} from 'hooks/incident/useRoster';
import { useDeleteSchedule } from 'hooks/incident/useSchedule';
import { useGetDraftRosterMembersForIncident } from './hooks/incidentRoster/useGetDraftRosterMembersForIncident';
import { useCreateDraftRoster } from './hooks/incidentRoster/useCreateDraftRoster';
import Loading from '../Loading/Loading';
import { RosterEntry } from 'components/IAP/hooks/incidentRoster/incidentRoster.types';

export const IapDraftRoster = () => {
  const incidentId = useActualIncidentId();
  const groupGuid = useGroupGuid();

  const { data: draftRosterData = [], isLoading: isRosterLoading } =
    useGetDraftRosterMembersForIncident();

  const { mutate: removeUser } = useRemoveMemberFromIncidentRoster(
    incidentId,
    groupGuid
  );
  const { mutate: removeSelf } = useRemoveSelfFromRoster(incidentId, groupGuid);
  const { mutate: markActive } = useMarkIncidentUserActive(
    incidentId,
    groupGuid
  );
  const { mutate: deleteSchedule } = useDeleteSchedule(incidentId, groupGuid);
  const createDraftRoster = useCreateDraftRoster();

  if (!incidentId) {
    return null;
  }

  if (isRosterLoading) {
    return <Loading />;
  }

  if (!isRosterLoading && draftRosterData.length === 0) {
    return (
      <div className="text-center">
        <p className="mb-3">No draft roster exists for this incident.</p>
        <StylishNewButton
          className="button--primary"
          onClick={() => createDraftRoster.mutate()}
          disabled={createDraftRoster.isPending}
        >
          {createDraftRoster.isPending
            ? 'Creating Draft Roster...'
            : 'Create Draft Roster'}
        </StylishNewButton>
      </div>
    );
  }

  return (
    <>
      <IncidentRosterView
        isDraft
        rosterData={draftRosterData as RosterEntry[]}
        isRosterLoading={isRosterLoading}
        showApprovalAuthority={false}
        onRemoveMember={(member) =>
          removeUser({
            user: {
              user_guid: member.userId,
              incident_member_id: member.incidentMemberId,
              email_address: member.emailAddress || '',
            },
          })
        }
        onRemoveSelf={(member) =>
          removeSelf({
            user: {
              user_guid: member.userId,
              incident_member_id: member.incidentMemberId,
              email_address: member.emailAddress || '',
            },
          })
        }
        onMarkActive={(member) => {
          const userGuid = member.userId;
          const incidentMemberId = member.incidentMemberId;

          markActive({
            user_guid: userGuid,
            incident_member_id: incidentMemberId,
          });
        }}
        onDeleteScheduleConfirmed={({
          scheduleId,
          userGuid,
          incidentMemberId,
        }) =>
          deleteSchedule({
            scheduleId,
            user_guid: userGuid,
            incident_member_id: incidentMemberId,
          })
        }
      />
    </>
  );
};
